var _rect, _rect2, _rect3, _path, _rect4, _path2, _path3, _path4, _path5, _rect5, _path6, _path7, _path8, _path9, _rect6, _path10, _path11, _path12, _path13, _path14, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFlowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 241,
    viewBox: "0 0 235 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 22,
    width: 188,
    height: 176,
    rx: 12,
    fill: "#4C637B",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 28,
    width: 176,
    height: 164,
    rx: 8,
    fill: "#142433"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.75,
    y: 43.75,
    width: 26.5,
    height: 26.5,
    rx: 13.25,
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.334 56.333V52.333H39.6673V56.333H43.6673V57.6663H39.6673V61.6663H38.334V57.6663H34.334V56.333H38.334Z",
    fill: "#768CFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98.75,
    y: 43.75,
    width: 48.5,
    height: 26.5,
    rx: 3,
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107 50H139",
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107 57H139",
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107 64H120",
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M102 50.75C102 48.6789 103.679 47 105.75 47H148.25C150.321 47 152 48.6789 152 50.75V71.25C152 73.3211 150.321 75 148.25 75H105.75C103.679 75 102 73.3211 102 71.25V50.75Z",
    fill: "#3B57E9",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.75,
    y: 96.75,
    width: 48.5,
    height: 26.5,
    rx: 3,
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82 103H114",
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82 110H114",
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117H95",
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M77 103.75C77 101.679 78.6789 100 80.75 100H123.25C125.321 100 127 101.679 127 103.75V124.25C127 126.321 125.321 128 123.25 128H80.75C78.6789 128 77 126.321 77 124.25V103.75Z",
    fill: "#3B57E9",
    fillOpacity: 0.3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 47.75,
    y: 149.75,
    width: 48.5,
    height: 26.5,
    rx: 3,
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56 156H88",
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56 163H88",
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56 170H69",
    stroke: "#768CFF",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51 156.75C51 154.679 52.6789 153 54.75 153H97.25C99.3211 153 101 154.679 101 156.75V177.25C101 179.321 99.3211 181 97.25 181H54.75C52.6789 181 51 179.321 51 177.25V156.75Z",
    fill: "#3B57E9",
    fillOpacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57H98M152 57H154C165.046 57 174 65.9543 174 77V89.8576C174 100.903 165.046 109.858 154 109.858L127 109.858M73.5 109.858H52C40.9543 109.858 32 118.812 32 129.858V148C32 156.284 38.7157 163 47 163V163M101 163L140.5 163",
    stroke: "#3B57E9",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1541_460286)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 133,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#142433"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.75,
    y: 141.75,
    width: 62.5,
    height: 62.5,
    rx: 31.25,
    fill: "#142433",
    stroke: "#768CFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5 170H189L175.5 189.5V176H165L178.5 156.5V170Z",
    fill: "#768CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1541_460286",
    x: 119,
    y: 125,
    width: 116,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1541_460286"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1541_460286",
    result: "effect2_dropShadow_1541_460286"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1541_460286",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFlowDark);
export default __webpack_public_path__ + "static/media/empty-flow-dark.f7e6a08a994b7cd6948c35b1c867e67d.svg";
export { ForwardRef as ReactComponent };